import styled from '@emotion/styled';
import { Typography as JDTypography, TypographyProps, grey, navy, red, tokens } from '@galaxy-react/core';
import classNames from 'classnames';

type Props = TypographyProps & {
  type?: 'brand' | 'sub-brand' | 'secondary' | 'error' | 'default';
};
const StyledTypography = styled(JDTypography)({
  whiteSpace: 'pre-wrap',
  '&.brand': {
    color: tokens.colorBrandStroke1,
  },
  '&.secondary': {
    color: grey[600],
  },
  '&.sub-brand': {
    color: navy[700],
  },
  '&.error': {
    color: red[500],
  },
});
const Typography = (props: Props) => {
  const { type, className, ...restProps } = props;
  return <StyledTypography className={classNames(type, classNames)} {...restProps}></StyledTypography>;
};

export default Typography;
